import { render, staticRenderFns } from "./BaseTop.vue?vue&type=template&id=15765c40&scoped=true&"
import script from "./BaseTop.vue?vue&type=script&lang=js&"
export * from "./BaseTop.vue?vue&type=script&lang=js&"
import style0 from "./BaseTop.vue?vue&type=style&index=0&id=15765c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15765c40",
  null
  
)

export default component.exports